import { EnumValueObject } from "src/contexts/_shared/domain/EnumValueObject";
import { InvalidDocumentWithContentTypeError } from "src/contexts/_shared/domain/errors/InvalidDocumentWithContentTypeError";

export enum DocumentWithContentAcceptedTypes {
  PDF = "application/pdf",
  JPEG = "image/jpeg",
  PNG = "image/png",
  JPG = "image/jpg",
}

export class DocumentWithContentAcceptedContentType extends EnumValueObject<DocumentWithContentAcceptedTypes> {
  constructor(value: string) {
    super(value, Object.values(DocumentWithContentAcceptedTypes));
  }

  protected throwErrorForInvalidValue(value: DocumentWithContentAcceptedTypes): void {
    throw new InvalidDocumentWithContentTypeError(value.toString());
  }
}
